import {
  FETCH_SCHOOL_ISIR_REC_INFO,
  FETCH_AVAILABLE_AID_YEARS,
  FETCH_SCHOOL,
  FETCH_ROLES,
  FETCH_ROLE_PERMISSION_LINKS,
  FETCH_NESTED_CATEGORIES,
  UPDATE_SSO_USER_SCHOOLCODE,
  FETCH_SCHOOL_LOGO,
  UPDATE_AID_YEAR,
  SET_DEFAULT_AID_YEAR,
} from "./types";
import SchoolService from "../services/SchoolService";
import AuthService from "../services/AuthService";
import history from "../history";
import { LOGO } from "../utilities/FileType";
import { fetchIsirRecElementInfo } from "./AdminActions";
import { fetchPermissions } from "./PermissionActions";
import { Dispatch } from "redux";

export const fetchSchoolIsirRecInfo = (schoolCode: string, aidYear: number) => {
  return async (dispatch: Dispatch<any>) => {
    const response = await SchoolService.getSchoolIsirRecInfo(
      schoolCode,
      aidYear
    );
    dispatch({ type: FETCH_SCHOOL_ISIR_REC_INFO, payload: response });
  };
};

export const getSchoolInfo = (schoolCode: string) => {
  return async (dispatch: Dispatch<any>) => {
    let school: School | undefined = await SchoolService.getSchool(schoolCode);
    if (school) {
      dispatch({ type: FETCH_SCHOOL, payload: school });
    }

    let aidYears: number[] | undefined = await SchoolService.getAvailableAidYears(schoolCode);
    if (aidYears) {
      dispatch({ type: FETCH_AVAILABLE_AID_YEARS, payload: aidYears });
    }
  };
};

export const getSchoolLogo = (schoolCode: string) => {
  return async (dispatch: Dispatch<any>) => {
    let response: string | undefined | boolean = await SchoolService.getSchoolFile(
      schoolCode,
      LOGO,
      false
    );
    if (!response) {
      console.log("Logo could not be downloaded");
    } else {
      dispatch({ type: FETCH_SCHOOL_LOGO, payload: response });
    }
  };
};

export const getSchoolLogoForLogin = (schoolCode: string) => {
  return async (dispatch: Dispatch<any>) => {
    let response: string | undefined | boolean= await AuthService.getSchoolFile(schoolCode, LOGO);
    if (!response) {
      console.log("Logo could not be downloaded");
    } else {
      dispatch({ type: FETCH_SCHOOL_LOGO, payload: response });
    }
  };
};

export const getSchoolDataForLogin = (schoolCode: string) => {
  return async (dispatch: Dispatch<any>) => {
    let response = await AuthService.getSchoolDataForLogin(schoolCode);
    if (!response) {
      console.log("Logo could not be downloaded");
    } else {
      dispatch({ type: FETCH_SCHOOL, payload: response });
    }
  };
};

export const switchSchool = (schoolCode: string, redirectPath: string, newAidYear: number) => {
  return async (dispatch: Dispatch<any>) => {
    // Update the sso user schoolcode
    dispatch({
      type: UPDATE_SSO_USER_SCHOOLCODE,
      payload: schoolCode,
    });


    // Update the token
    // This needs to be ran before the other methods can be run in parallel
    await AuthService.updateToken({
      claim: "SCHOOL_CODE",
      newValue: schoolCode,
    });
    let school: School | undefined;
    await SchoolService.getSchool(schoolCode).then((response) => {
      if (response) {
        school = response;
        dispatch({ type: FETCH_SCHOOL, payload: response });
      }
    });
    await Promise.all([
      SchoolService.getAvailableAidYears(schoolCode).then((response) => {
        if (response) {
          let defaultAidYear = school?.defaultAidYear;
          
          if(newAidYear && response.includes(newAidYear)){
            defaultAidYear = newAidYear;
          } else if (defaultAidYear === null) {
            defaultAidYear = response[0];
          }

          dispatch({ type: FETCH_AVAILABLE_AID_YEARS, payload: response });
          dispatch({ type: SET_DEFAULT_AID_YEAR, payload: defaultAidYear });
          if (response.length === 1) {
            dispatch({ type: UPDATE_AID_YEAR, payload: defaultAidYear });
            dispatch(fetchIsirRecElementInfo(defaultAidYear))
          }

          dispatch(fetchIsirRecElementInfo(defaultAidYear));
        }
      }),
      dispatch(fetchPermissions()),
      SchoolService.getAllRoles().then((response) => {
        if (response) {
          dispatch({ type: FETCH_ROLES, payload: response });
        }
      }),
      SchoolService.getAllRolePermissionLinks().then((response) => {
        if (response) {
          dispatch({ type: FETCH_ROLE_PERMISSION_LINKS, payload: response });
        }
      }),
      SchoolService.getNestedCategories().then((categories) => {
        if (categories) {
          dispatch({ type: FETCH_NESTED_CATEGORIES, payload: categories });
        }
      }),
    ]);
    if (redirectPath) history.push(redirectPath);
  };
};
